export default {
  headerContent: {
    title: 'Quick Sigorta Zorunlu Deprem Sigortası (DASK) Fiyatları',
    slogan: "Zorunlu Deprem Sigortası'nı işin uzmanına bırak.",
    btnTitle: 'DASK TEKLİFİ AL'
  },
  crossPageContent: {
    mainTitle: 'Quick Sigorta DASK',
    description: {
      title:
        'Quick Sigorta DASK (Zorunlu Deprem Sigortası) Nedir? DASK Ne Demek? ',
      content: [
        'Quick Sigorta zorunlu deprem sigortası ile deprem risklerini koruma altına alabilirsiniz.',
        'Zorunlu deprem sigortası, deprem sonucunda oluşan yangın, tsunami ve yer kayması gibi hasarlar poliçede belirtilmiş limitler kadar güvence vererek sigortalının uğrayacağı maddi kayıpları önlemektedir.'
      ]
    },
    subContent: {
      title: 'Quick Sigorta Zorunlu Deprem Sigortası Teminatları Neler?',
      content: [
        {
          paragraph: 'Zorunlu deprem sigortası teminatları;',
          subList: [
            'Deprem sonrası maddi zarar,',
            'Deprem sonrası yangın,',
            'Deprem sonrası infilak,',
            'Deprem sonrası tsunami,',
            'Deprem sonrası yer kayması teminatından oluşmaktadır.'
          ]
        }
      ]
    }
  },
  getPrice: {
    mainTitle: 'DASK Sigortası Teklifi Nasıl Alınır?',
    campaigns: [
      {
        id: 1,
        name: 'DASK Sigortası',
        assurance: 'Ek Teminatlı',
        price: '+50 TL'
      },
      {
        id: 2,
        name: 'DASK Sigortası',
        assurance: 'Standart Teminatlı',
        price: '+50 TL'
      },
      {
        id: 3,
        name: 'DASK Sigortası',
        assurance: 'Zorunlu Teminatlı',
        price: '+50 TL'
      },
      {
        id: 4,
        name: 'DASK Sigortası',
        assurance: 'Ek Teminatlı',
        price: '+50 TL'
      }
    ]
  },
  faqTitle: 'Quick Sigorta DASK Sigortası Hakkında Merak Edilenler',
  faqTitleDesc: 'Her gün yayınlanan güvenilir bilgilere kolay erişim.',
  questions: []
}
